import { useMutation } from '@tanstack/react-query';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { bulkClaimOnBehalf } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service';
import { BulkClaimOnBehalfRes } from '@dealstack/shared/lib/generated';

export const useBulkClaimOnBehalf = ({
	dealId,
	programmeId,
	onSuccess,
	onSettled,
}: {
	dealId: string;
	programmeId: string;
	onSuccess?: (data: ApiV1.Response<BulkClaimOnBehalfRes>) => void;
	onSettled?: () => void;
}) => {
	const tMipManage = useTranslationMipManage();

	const handleError = () => {
		showToastV2({
			state: 'error',
			title: tMipManage('documents_page.toast.claim_on_behalf.error'),
		});
	};

	return useMutation({
		mutationFn: (body: { signerIds: string[] }) =>
			bulkClaimOnBehalf({ dealId, programmeId, body }),
		onSuccess,
		onError: handleError,
		onSettled,
	});
};
